import { Link, Tooltip } from '@routable/gross-ds';
import pluralize from 'pluralize';
import React from 'react';
import { PLATFORM_DISPLAY_SHORT_NAME } from 'constants/platform';
import helpDocs from 'helpers/helpDocs';
import { listAllElementsInArray } from 'helpers/stringHelpers';
import { lengthOf } from 'helpers/utility';
const CurrencyNotSupportedByPlatformTooltip = ({ children, currencies, isShown, partnershipType, position = 'right', }) => {
    const currenciesText = listAllElementsInArray(currencies);
    const currencyOrCurrencies = pluralize('currency', lengthOf(currencies));
    return !isShown ? (children) : (React.createElement(Tooltip, { closeDelay: 100, "data-testid": "tooltip--currency-not-supported-by-platform", position: position, tooltip: React.createElement("span", { className: "text-xs" },
            `${PLATFORM_DISPLAY_SHORT_NAME} doesn't yet support this ${partnershipType}'s ${currencyOrCurrencies} (${currenciesText}). `,
            React.createElement(Link, { href: helpDocs.PARTNER_COUNTRY_CURRENCY_HINT, openInNewTab: true }, "Learn more about supported countries and currencies")), variant: "light" }, children));
};
export default CurrencyNotSupportedByPlatformTooltip;
